const image_background = process.env.images && process.env.images.background ? 
    require(process.env.images.background) : require('@/assets/images/hinh_nen_login_fastpro.jpg');
const image_header_kqsb = process.env.images && process.env.images.header_kqsb ? 
    require(process.env.images.header_kqsb) : require('@/assets/images/header_kqsb_fastpro.png');
export { image_background, image_header_kqsb }; 